import { render, staticRenderFns } from "./son3.vue?vue&type=template&id=621d4f56&scoped=true"
import script from "./son3.vue?vue&type=script&lang=js"
export * from "./son3.vue?vue&type=script&lang=js"
import style0 from "./son3.vue?vue&type=style&index=0&id=621d4f56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621d4f56",
  null
  
)

export default component.exports